import { render, staticRenderFns } from "./procurement_party_notification.vue?vue&type=template&id=021b3ea8&scoped=true&"
import script from "./procurement_party_notification.vue?vue&type=script&lang=js&"
export * from "./procurement_party_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b3ea8",
  null
  
)

export default component.exports